import React from "react";

import useStores from "../../../../../../utils/useStores";
import { observer } from "mobx-react";
import { QuizObjectListComponent } from "./List";

import "./style.css";
import { QuizObject } from "../../../../../../store/modquiz/quiz_objects/quiz-object";

type ListsContainerProps = {
    quiz_object: QuizObject;
    focusField: Function;
    blurField: Function;
};

const ListsContainer = observer(
    ({ quiz_object, focusField, blurField }: ListsContainerProps) => {
        const rootStore = useStores();

        let quiz_objects = rootStore.objectStore.quiz_objects;
        let lists = quiz_objects.get(quiz_object._id).lists;

        return (
            <div className="row">
                {lists.map((list: any, i: number) => {
                    if (!list.deleted) {
                        return (
                            <span>
                                <div className="quiz-object-edit-title">
                                    List
                                </div>

                                <QuizObjectListComponent
                                    key={i}
                                    list={list}
                                    showHelp={focusField}
                                    hideHelp={blurField}
                                />
                            </span>
                        );
                    }
                })}
            </div>
        );
    }
);

export default ListsContainer;
